import React from 'react'
import { TextField, InputAdornment, SxProps, Theme } from '@mui/material'
import { Search as SearchIcon } from '@mui/icons-material'

interface SearchFieldProps {
  value: string
  onChange: (value: string) => void
  onSearch?: () => void
  placeholder?: string
  fullWidth?: boolean
  sx?: SxProps<Theme>
}

export const SearchField: React.FC<SearchFieldProps> = ({
  value,
  onChange,
  onSearch,
  placeholder = '',
  fullWidth = false,
  sx,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && onSearch) {
      onSearch()
    }
  }

  return (
    <TextField
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={handleKeyDown}
      placeholder={placeholder}
      size="small"
      fullWidth={fullWidth}
      sx={{
        minWidth: 250,
        '& .MuiOutlinedInput-root': {
          backgroundColor: 'background.paper',
        },
        ...sx,
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon color="action" />
          </InputAdornment>
        ),
      }}
    />
  )
}
